module.exports = __webpack_public_path__ + "img/system-1.39b2a9e7.png";